<template>
  <BModal
    active
    has-modal-card
    @close="() => $router.push({ name: 'NewSalaryReceipt' })"
  >
    <form
      class="modal-card"
      style="width: auto"
      @submit.prevent="create"
    >
      <header class="modal-card-head">
        <p class="modal-card-title has-text-primary">
          Crear nuevo empleado
        </p>
      </header>
      <section class="modal-card-body">
        <NewBasicEmployee :loading="loading" />
      </section>
      <footer class="modal-card-foot">
        <RouterLink
          class="button"
          :to="{ name: 'NewSalaryReceipt' }"
        >
          Cerrar
        </RouterLink>

        <button
          type="submit"
          class="button is-primary"
        >
          Crear empleado
        </Button>
      </footer>
    </form>
  </BModal>
</template>

<script>
export default {
  name: 'PushBasicEmployee',
  components: {
    NewBasicEmployee: () => import(/* webpackChunkName: "new-basic-employee" */ '@/components/Admin/Payroll/NewBasicEmployee.vue'),
  },
  data() {
    return { loading: false };
  },
  methods: {
    async create(event) {
      event.stopPropagation();
      this.loading = true;
      try {
        await this.$store.dispatch('employee/createBasicEmployee');
        this.$success({ message: 'Empleado creado exitosamente' });
        this.$router.push({ name: 'NewSalaryReceipt' });
      } catch (error) {
        this.$danger({ message: error.message });
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
</style>
